import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    cluster:
      'absolute top-1/2 left-1/2 flex size-16 -translate-x-1/2 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full border border-white bg-black',
    count: 'heading-m-bold text-white'
  }
});
